import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const itemPriceManagementAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.itemPriceManagement],
  permissions: [Permission.ItemPriceManagementView],
}

export const itemPriceManagementViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementView],
}

export const itemPriceManagementModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementModify],
}

export const itemPriceManagementDeleteChangeRequestAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementDeleteChangeRequest],
}

export const itemPriceManagementReviewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementReview],
}

export const itemPriceManagementPartnerApproveAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementPartnerApprove],
}

export const itemPriceManagementDebugAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementDebug],
}
